
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import { Booklet } from '../types';
import { CDN_URLS, RESOURCE_LINKS } from '../config';

export const booklets: Booklet[] = [
  {
    id: 'guide-minimalism',
    titleKey: 'booklet_minimalist_title',
    descriptionKey: 'booklet_minimalist_desc',
    category: 'style',
    coverImageUrl: `${CDN_URLS.UNSPLASH}photo-1496747611176-843222e1e57c?q=80&w=400&auto=format&fit=crop`,
    fileSize: '2.4 MB',
    downloadUrl: RESOURCE_LINKS.MINIMALISM_PDF
  },
  {
    id: 'guide-color-theory',
    titleKey: 'booklet_color_theory_title',
    descriptionKey: 'booklet_color_theory_desc',
    category: 'color',
    coverImageUrl: `${CDN_URLS.UNSPLASH}photo-1502163140606-888448ae8cfe?q=80&w=400&auto=format&fit=crop`,
    fileSize: '4.1 MB',
    downloadUrl: RESOURCE_LINKS.COLOR_THEORY_PDF
  },
  {
    id: 'guide-executive',
    titleKey: 'booklet_executive_title',
    descriptionKey: 'booklet_executive_desc',
    category: 'business',
    coverImageUrl: `${CDN_URLS.UNSPLASH}photo-1483985988355-763728e1935b?q=80&w=400&auto=format&fit=crop`,
    fileSize: '1.8 MB',
    downloadUrl: RESOURCE_LINKS.EXECUTIVE_STYLE_PDF
  },
  {
    id: 'guide-capsule',
    titleKey: 'booklet_capsule_title',
    descriptionKey: 'booklet_capsule_desc',
    category: 'style',
    coverImageUrl: `${CDN_URLS.UNSPLASH}photo-1485230946086-614024086a55?q=80&w=400&auto=format&fit=crop`,
    fileSize: '3.2 MB',
    downloadUrl: RESOURCE_LINKS.CAPSULE_WARDROBE_PDF
  }
];
